import { render, staticRenderFns } from "./AdminMedicineList.vue?vue&type=template&id=2f2949e1"
import script from "./AdminMedicineList.js?vue&type=script&lang=js&external"
export * from "./AdminMedicineList.js?vue&type=script&lang=js&external"
import style0 from "./AdminMedicineList.vue?vue&type=style&index=0&id=2f2949e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports